import React from 'react';
import AppRouters from "settings/app-routers";
import clsx from "clsx";

import styles from './example.module.scss';

export const Example = () => {
    return (
        <div className={styles.container}>
            <h3>
                Conoce nuestro reporte vehicular
            </h3>

            <p>
                Brindamos información relevante y actualizada. Además, incluimos los certificados de Anotaciones
                Vigentes y de Multas No Pagadas (en caso de tener).
            </p>

            <a onClick={() => window.open(AppRouters.reportDemo, '_blank')} className={clsx("btn btn-outline-primary form-control btn-outline", styles.btnShowPdf)}>
                <span>Ver Reporte Ejemplo</span>
            </a>
        </div>
    );
};
